<template>
  <div class="app-header">
    <div class="header">
      <div class="header-body">
        <div class="nav-bar">
          <div class="nav-bar-logo">
            <a
              :href="siteConfig.logoLink == '' ? '/' : siteConfig.logoLink"
              v-show="siteConfig.logoFB"
            >
              <img :src="concatImageUrl(siteConfig.logoFB)" />
            </a>
          </div>
          <ul class="nav-bar-list" v-if="routeModel == 1">
            <li v-if="agencyId != 3122">
              <router-link
                :class="{ selected: $route.path == '/' }"
                :to="{ path: '/' }"
                >首 页</router-link
              >
            </li>
            <li v-else>
              <a target="_blank" href="https://zhishengyunxue.com">首 页</a>
            </li>
            <li>
              <app-drop-nav theme="black"></app-drop-nav>
            </li>
          </ul>
          <ul class="nav-bar-list" v-if="routeModel == 1">
            <li v-for="(item, index) in navList.slice(0, 3)" :key="index">
              <template v-if="item.navType == 1">
                <a v-if="item.url" :href="item.url" target="_blank">{{
                  item.name
                }}</a>
                <router-link
                  v-else
                  :class="{
                    selected: $route.path.indexOf(`product/${item.id}`) > -1,
                  }"
                  :to="{ name: 'ProductDiyList', params: { id: item.id } }"
                  >{{ item.name }}</router-link
                >
              </template>
              <template v-else-if="item.navType == 2">
                <router-link
                  :class="{ selected: $route.path.indexOf('teacher') > -1 }"
                  :to="{ name: 'TeacherList' }"
                  >{{ item.name }}</router-link
                >
              </template>
              <template v-else-if="item.navType == 3">
                <router-link
                  v-if="item.id > 0"
                  :class="{
                    selected: $route.path.indexOf(`news/${item.id}`) > -1,
                  }"
                  :to="{ name: 'NewsList', params: { id: item.id } }"
                  >{{ item.name }}</router-link
                >
                <router-link
                  v-else
                  :class="{
                    selected: $route.path.indexOf(`news/`) > -1,
                  }"
                  :to="{ name: 'News' }"
                  >{{ item.name }}</router-link
                >
              </template>
              <template v-else>
                <router-link
                  :class="{ selected: $route.path.indexOf('about') > -1 }"
                  :to="{ name: 'About' }"
                  >{{ item.name }}</router-link
                >
              </template>
            </li>
          </ul>
          <div
            class="nav-bar-more"
            v-if="navList.length > 3 && routeModel == 1"
          >
            <span class="more-icon">
              <Icon type="ios-more" />
            </span>
            <div class="more-box">
              <ul class="more-drop">
                <li v-for="(item, index) in navList.slice(3)" :key="index">
                  <template v-if="item.navType == 1">
                    <a v-if="item.url" :href="item.url" target="_blank">{{
                      item.name
                    }}</a>
                    <router-link
                      v-else
                      :to="{ name: 'ProductDiyList', params: { id: item.id } }"
                      >{{ item.name }}</router-link
                    >
                  </template>
                  <template v-else-if="item.navType == 2">
                    <router-link :to="{ name: 'TeacherList' }">{{
                      item.name
                    }}</router-link>
                  </template>
                  <template v-else-if="item.navType == 3">
                    <router-link
                      v-if="item.id > 0"
                      :to="{ name: 'NewsList', params: { id: item.id } }"
                      >{{ item.name }}</router-link
                    >
                    <router-link v-else :to="{ name: 'News' }">{{
                      item.name
                    }}</router-link>
                  </template>
                  <template v-else>
                    <router-link :to="{ name: 'About' }">{{
                      item.name
                    }}</router-link>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header-info">
          <div class="header-search" v-if="navVisible">
            <input
              type="text"
              v-model="keywords"
              placeholder="搜索课程代码/名称"
              @keyup.enter="searchProduct"
            />
            <div class="search-icon" @click="searchProduct">
              <Icon custom="ich-icon ich-icon-search" size="20" />
            </div>
          </div>
          <div class="header-message">
            <span class="header-message-icon">
              <Icon custom="ich-icon ich-icon-bell" />
            </span>
            <div class="header-message-box">
              <div class="header-message-drop">
                <div class="header-message-title">消息盒</div>
                <ul class="header-message-body" v-if="messageList.length > 0">
                  <li v-for="(item, index) in messageList" :key="index">
                    <a href="javascript:;">{{ item.title }}</a>
                  </li>
                </ul>
                <div
                  v-else
                  class="header-message-body"
                  style="text-align: center; padding: 15px 0"
                >
                  暂无未读消息
                </div>
                <router-link :to="{ name: 'Message' }">
                  <a href="javascript:;" class="header-message-footer"
                    >查看全部</a
                  >
                </router-link>
              </div>
            </div>
          </div>

          <template v-if="!isLogin">
            <router-link class="header-link" :to="{ name: 'Login' }">
              {{ siteConfig.isAllowRegister ? "登录/注册" : "登 录" }}
            </router-link>
            <a
              href="javascript:;"
              v-if="siteConfig.isAllowTrail"
              @click="trialLogin"
              class="header-link-out"
            >
              试 用
            </a>
          </template>
          <template v-else>
            <router-link class="header-link" :to="{ name: 'MemberCenter' }"
              >学习中心</router-link
            >
            <a class="header-link-out" href="javascript:;" @click="logout()"
              >退 出</a
            >
          </template>
          <template> </template>
        </div>

        <div
          v-if="siteConfig.agencyId === 4089"
          style="
            position: absolute;
            color: rgb(221, 57, 36);
            font-size: 20px;
            background: rgb(0, 0, 0, 0);
            height: 70px;
            line-height: 70px;
            top: -10px;
            right: -280px;
          "
        >
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFcklEQVRYR62Xe4hUVRzHv787c8+sG0pZEa07dzbcde4dS3xVaCmKaGkQGCYZaVpZYLQlpD2U1ELZHmChPTC2siTMcpUMtQdpGEZo9FB3Z1ofO/eu+QgKwXTnzMz5xdGddXZ27sy6eP+bOef3O5/7e3zP7xJ8noRVMYlJPQjGHQCiBBxSwBeOK5f72fTlfypm1GKJ5QQsu7DG/DeAQyAaDuBqMD6wPfloXw4rZtMDIO/wL4novWgytUMbHqwxhwezWA2iCQx+wnHT664ERDeAvMOPkQqMi7afP55/SFuk8sYOzuwHcMJ25egrDhC3xE4AdymF+2Ltckup9BCr8VEvs6fonurgBDKMXQw0iKBsGHwUZ/xguyLQWosBWSnOgOHanoz4FmckNJWZtzOwwq8gW2oqaojVS2DMA3CACQ1OUn5asgYSnY6JqTHqpR4rFd64JRjAXtuVukN8n+aweMAgLAFwMwEvRF3ZULi5KwLxiFgKxius1ESnPbO7HAABR6KurPVLE0h94yQzew9VY2DQMDcyaDKYF9he+t18m0sAVqge4LcUY3rMk1vLAQA4a7uyf7F9nRFCLk0HwqHBJvEuAGHFmBXz5MacXRdAS9icS0QfMvM8x0t/5AfQ0llgAH6zXTmi2L6EJbSG3M/AUAAbbFfOTkTEdGY0AfjcduXMHgC5DQq0MOam3izmWIfTMES9FilmLHE8uSp/n34JENUEgU11rmxusUQrAbVENC19LrXH7CdOM3DeduW1PQG09EJ951fdcUssBvAcgIEMPkWKptjt8o9uAPkKCnWnQuBWA7yawWscN12fsEI/MHg8kxrrJDM/aduuFByMQQTPihSAfbYrbyuMQC6vAD5RjCa/OsmJGTGvDRnmqg7O/KV92a6k3Fr+S3ZTwrglNuncBU1xQ+2Rs6fzITQAASuiZS6jrhohbGUyFpJSx8C82/bSE+Nh820QLfAFSFjmHAatZ/Bcx02vLwA4psMfAMbo/PoVqRY0JcVefXPqWsjqi4zxhu3JRbkXNED1Q9zUmm4p0D9+H9SvOhTIegR6P+qmHi8sMN0lYGq0ywhVYV2YijbUtqcOx8Pmrs7LbLTjpn/pAaD/SFhiGwMjKyg4uiZ57kS3KOQcMN3teKmvS2mFn0ARECvahjmDXDsW64bmajHdMNBEoB+FkZp8Uxs6LhfCV4q759v8HqCoTxQuFhLzWsdLP5Wz08WXCRinBrA8GXHxb2/Bik5EcUs8pNutWBRaaxHKpsydOpdEPJ//S3+GSqFldlTeodsM0LohbuqrciBFAbRR3BI/A6g2YIwb4nYczXfUHDFHGgoa4noAWlDGaFgDVAWomgsXz8VnW4B4WV0y/asfiC9AwjJnM+hjBjY7rpxR6KBTVOYDqNLRsl05pysdYTELwNNEuB3AcQWaF3NT3xaD8AW4EIWweB2EZ8FYantyZaGD+HXozxXBUX7Xd67vtV2W1fihRSaokgCdqdDtNkUR3RNLpraXy6lPpJaBscP25LRedUG3jqgWw2BAHzxIUbAqVqANvQGKh8V2EKYyYYaTlJvzbcpGQG/OmwGgGLfEPHmwNwdfqomLswaA12xX6hu16+kVQCEECCvtpFzaW4hmK/SMvpZ1V9iuvLdPANqo1RKxLKA1vEJPNv8o+fDYdpwvBxIPi0YQHgHwqu3K5/sMkIPIABsI0OPYPgP0cinB+TMsZimCHsnPBKSsqzsJ/al3+SnIN9pfhcqrgmIxAYsAVOrQMnMTAoHdTltHWx7ozNw3JjE/GfXS71x2F5QKb2vEHJFlzGXQbAKuKbaXCFtAeDHaJuNF18vlrzfrh6v6hdOBzCQijABjGBG1KSCZG05L+fgfdAFtP9BsQqAAAAAASUVORK5CYII="
            style="
              display: inline-block;
              vertical-align: middle;
              width: 24px;
              height: 24px;
              margin-right: 6px;
            "
          />{{ siteConfig.footerTel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { global, user, account } from "../../request";
import AppDropNav from "./AppDropNav";
import VueQr from "vue-qr";
export default {
  mixins: [siteMixin],
  data() {
    return {
      keywords: "",
      appQrcodeData: {
        url: "",
        icon: "",
      },
      isCustomApp: false,
      navList: [],
      messageList: [],
      navVisible: true,
      agencyId: 0,
    };
  },
  mounted() {
    this.initData();
    this.keywords = this.$route.query.k ?? "";
    this.setQrCode();
    this.getMessageList();
  },
  watch: {
    $route(to, from) {
      if (to.query.k !== from.query.k) {
        // 有地区不清空搜索内容
        if(to.query.a) return;
        this.keywords = to.query.k;
      }
    },
  },
  methods: {
    initData() {
      this.agencyId = this.siteConfig.agencyId;
      this.navVisible = this.routeModel == 1;
      if (this.navVisible) {
        this.getNavList();
      }
    },
    searchProduct() {
      if (!this.keywords) return;
      this.$router.push({ name: "ProductList", query: { k: this.keywords } });
    },
    setQrCode() {
      if (
        this.siteConfig.agencyId > 0 &&
        this.siteConfig.appDownAndroid &&
        this.siteConfig.appDownApple &&
        this.siteConfig.qrCodeLogo
      ) {
        this.isCustomApp = true;
        this.appQrcodeData = {
          url: window.location.protocol + "//" + document.domain + "/app",
          icon: this.concatImageUrl(this.siteConfig.qrCodeLogo),
        };
      }
    },
    trialLogin() {
      account.trialLogin(this.siteConfig.agencyId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.login(res.data);
          this.$router.push({ name: "MemberCenter" });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getMessageList() {
      if (!this.isLogin) return;
      user.getMessage(0, this.loginUser.userId).then((res) => {
        if (res.status === 1) {
          this.messageList = res.data.slice(0, 6);
        }
      });
    },
    getNavList() {
      global.getNavList(this.siteConfig.agencyId).then((result) => {
        if (result.status == 1) {
          this.navList = result.data;
        }
        //console.log(result);
      });
    },
  },
  components: {
    AppDropNav,
    VueQr,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
.app-header {
  width: 100%;
  .header {
    width: 100%;
    height: 70px;
    padding: 10px 0;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    &-body {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .nav-bar {
        flex: 1;
        .nav-bar-logo {
          height: 50px;
          min-width: 180px;
          max-width: 250px;
          overflow: hidden;
          margin: 0 20px 0 0;
          .inline-block();

          img {
            height: 50px;
            display: block;
          }
        }
        .nav-bar-list {
          .inline-block();
          li {
            display: inline-block;
            margin: -10px 15px;
            vertical-align: top;
            height: 70px;

            > a {
              position: relative;
              width: 70px;
              height: 100%;
              line-height: 70px;
              display: block;
              color: #aaa;
              font-size: 16px;
              text-align: center;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;

              &:hover {
                color: #227efa;
                font-weight: bold;
                &:before {
                  position: absolute;
                  content: " ";
                  border-bottom: 2px solid #227efa;
                  bottom: 15px;
                  left: 0;
                  width: 100%;
                }
              }
              &.selected {
                color: #fff;
                font-weight: bold;

                &:before {
                  position: absolute;
                  content: " ";
                  border-bottom: 2px solid #fff;
                  bottom: 15px;
                  left: 0;
                  width: 100%;
                }
              }
            }
          }
        }
        .nav-bar-more {
          position: relative;
          .inline-block();
          width: 30px;
          height: 70px;
          line-height: 70px;
          text-align: center;
          margin: -10px 10px;
          &:hover {
            // background-color: #41a5fd;
            &.selected,
            &:before {
              position: absolute;
              content: " ";
              border: 8px solid transparent;
              border-bottom: 8px solid #fff;
              bottom: 0;
              left: 7px;
            }
            .more-icon {
              color: #fff;
              font-size: 30px;
            }
            .more-box {
              visibility: visible;
              .more-drop {
                visibility: visible;
                transform: translateY(0);
              }
            }
          }
          .more-icon {
            display: block;
            color: #aaa;
            font-size: 26px;
            i {
              vertical-align: -0.16em;
            }
          }
          .more-box {
            position: absolute;
            top: 70px;
            left: -48px;
            width: 130px;
            height: auto;
            padding: 0 5px 5px 5px;
            overflow: hidden;
            visibility: hidden;
            .more-drop {
              visibility: hidden;
              width: 120px;
              background: #fff;
              box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
              color: #333;
              text-align: left;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              background-color: #fff;
              z-index: 40;
              transform: translateY(-100%);
              transition: transform 0.2s linear;
              padding: 10px 0;
              li {
                a {
                  display: block;
                  height: 36px;
                  line-height: 36px;
                  padding: 0 20px;
                  color: #666;
                  .ellipsis();
                  &:hover {
                    background-color: #41a5fd;
                    color: #fff;
                  }
                }
              }
            }
          }
        }
      }
      .header-info {
        position: relative;
        width: 350px;
        text-align: right;
        .header-search {
          height: 30px;
          margin: 10px 0;
          overflow: hidden;
          border: 1px solid #aaa;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50px;
          padding: 4px 10px 4px 15px;
          &:hover {
            border-color: #fff;
            .search-icon {
              color: #fff;
            }
          }
          .inline-block();
          input[type="text"] {
            width: 130px;
            height: 20px;
            border: none;
            outline: none;
            background-color: transparent;
            color: #fff;
            margin: 0;
            padding: 0;
            &::placeholder {
              color: #ccc;
            }
          }
          .search-icon {
            .inline-block();
            width: 20px;
            height: 20px;
            cursor: pointer;
            color: #aaa;
            i {
              margin-top: -3px;
            }
          }
        }
        .header-message {
          position: relative;
          margin: -10px 10px;
          height: 70px;
          .inline-block();
          .header-message-icon {
            display: inline-block;
            padding: 10px 10px;
            width: 50px;
            height: 50px;
            line-height: 48px;
            text-align: center;
            transition: transform 0.2s linear;
            color: #aaa;
            font-size: 24px;
          }
          .header-message-box {
            position: absolute;
            top: 70px;
            right: 0;
            width: 310px;
            padding: 0 5px 5px 5px;
            height: auto;
            overflow: hidden;
            visibility: hidden;
          }
          .header-message-drop {
            visibility: hidden;
            width: 300px;
            background: #fff;
            border-top: none;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            color: #333;
            text-align: left;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            background-color: #fff;
            z-index: 30;
            transform: translateY(-100%);
            transition: transform 0.2s linear;

            .header-message-title {
              height: 50px;
              line-height: 50px;
              font-size: 1.6rem;
              padding: 0 20px;
              border-bottom: 1px solid #ddd;
            }

            .header-message-body {
              padding: 5px 0;

              li a {
                display: block;
                padding: 8px 20px;
                color: #666;
                line-height: 22px;
                overflow: hidden;

                &:hover {
                  background-color: #41a5fd;
                  color: #fff;
                }
              }
            }

            .header-message-footer {
              display: block;
              font-size: 16px;
              text-align: center;
              padding: 10px 20px;
              text-align: center;
              border-top: 1px solid #ddd;
              color: #333;
            }
          }

          &:hover {
            &:before {
              position: absolute;
              content: " ";
              border: 8px solid transparent;
              border-bottom: 8px solid #fff;
              bottom: 0;
              left: 16px;
            }
            .header-message-icon {
              color: #fff;
              font-size: 28px;
            }
            // background-color: #41a5fd;
            .header-message-box {
              visibility: visible;
            }
            .header-message-drop {
              visibility: visible;
              transform: translateY(0);
            }
          }
        }
        .header-link {
          width: 92px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          vertical-align: middle;
          border-radius: 50px;
          text-align: center;
          .background-primary();
          transition: transform 0.2s ease;
          &:hover {
            transform: scale(1.05);
          }
        }
        .header-link-out {
          position: absolute;
          top: 10px;
          right: -100px;
          width: 92px;
          height: 30px;
          line-height: 28px;
          display: inline-block;
          vertical-align: middle;
          border-radius: 50px;
          text-align: center;
          border: 1px solid #fff;
          background: transparent;
          transition: transform 0.2s ease;
          color: #fff;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
</style>
